import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import { getPlantData, getClimateData } from "../../store/design/actions"
import { getAreas, updateArea, deleteArea, addArea } from "../../store/goals/actions"
import moment from 'moment';
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import Editable from 'react-x-editable'
import DatePicker from "react-datepicker"
import Spreadsheet from "react-spreadsheet";
import { useDrop } from "react-dnd";

import {
	Badge,
	Col,
	Collapse,
	CardHeader,
	Card,
	CardImg,
	CardBody,
	CardTitle,
	CardText,
	Button,
	Container,
	Dropdown,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Nav,
	NavItem,
	NavLink,
	Form,
	FormGroup,
	Label,
	Pagination,
	PaginationItem,
	PaginationLink,
	Row,
	TabContent,
	TabPane,
	Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"

import Plant from "./plant"
import Family from "./family"
import Guilds from "./guilds"

const Area = props => {
	const { area, areaExpand, setAreaExpand, currYear, guildResults,addPlantLog, deleteNote, createNewPlant, plantingCalendarOptions, calcPlantingCalendar,
		plantMap, areaIndex, areas, setAreas, noteTags, notes, noteDate, userareas, profile, transferPlant, deletePlant, variety,
		numPlants, currPlant, setCurrPlant, addPlantModal, addPlant, climateAverages,
		setAddPlantModal, setTableData, addHarvest, showCompleted, setNoteDate, setNotes, setNoteTags, deleteHarvest, onDeleteArea, onSearchGuild, onUpdateArea, unitmeasurement,  onUpdateCustomPlant,
		onGetCustomPlants, onSaveCustomPlant, transferModal, setTransferModal, customPlantEdit, space, setTotalSpace,
		timelineNotes, onCreateJournalEntry, onUpdateJournalEntry } = props

	const [deleteModal, setDeleteModal] = useState(false)
	const [deleteAreaIndex, setDeleteAreaIndex] = useState(null)
	const [singlebtn, setSinglebtn] = useState(false)
	const [expandMenu, setExpandMenu] = useState(false)
	const [addAreaModal, setAddAreaModal] = useState(false)
	const [name, setName] = useState()
	const [areaYear, setAreaYear] = useState()
	const [editAreaModal, setEditAreaModal] = useState(false)
	const [activeTab, setActiveTab] = useState("1")
	const [currArea, setCurrArea] = useState({plants:[]})
	const [summer, setSummer] = useState(Array(20).fill(false))
	const [spring, setSpring] = useState(Array(20).fill(false))
	const [fall, setFall] = useState(Array(20).fill(false))
	const [winter, setWinter] = useState(Array(20).fill(false))
	const [plantfamilyCard, setPlantFamilyCard] = useState(false)
	const [areaOptions, setAreaOptions] = useState(Array(20).fill(false))
	const [plantMappings, setPlantMappings] = useState({})
	const [{ canDrop, isOver }, drop] = useDrop(() => ({
		accept: "plant",
		collect: (monitor) => ({
			isOver: monitor.isOver(),
			canDrop: monitor.canDrop(),
		}),
		hover: (item, monitor) => {
		},
		drop: (item) => {
			if (areaIndex!=item.area) {
				var srcArea = areas[item.area]
				var plantIndex = srcArea.plants.indexOf(item.plant)
				srcArea.plants.splice(plantIndex,1)
				areas[areaIndex].plants = [...areas[areaIndex].plants, item.plant]
				onUpdateArea(srcArea)
				onUpdateArea(areas[areaIndex])
				setAreas(areas)
			}
		}
	}))


	const toNum = (v) => {
		if (v == null) return 0;
		if (typeof v === "number") return v;
		if (typeof v === "object" && v.N !== undefined) return parseFloat(v.N) || 0;
		return parseFloat(v) || 0;
	};

	function updateSpaceUsed(index1) {
		let spaceUsed = 0;

		const isAllSelected =
			!spring[index1] && !summer[index1] && !fall[index1] && !winter[index1];

		userareas[index1].plants
			.filter((plant) => {
				if (isAllSelected) return true;
				if (summer[index1] && plant.season_rotation === "Summer") return true;
				if (spring[index1] && plant.season_rotation === "Spring") return true;
				if (fall[index1] && plant.season_rotation === "Fall") return true;
				if (winter[index1] && plant.season_rotation === "Winter") return true;
				return false;
			})
			.forEach((plant) => {
				if (plant.status !== "Complete" && plant.status !== "Failed") {
					spaceUsed += toNum(plant.spaceUsed);
				}
			});

		// Guard: skip setAreas if value hasn't changed to prevent render loops
		if (Math.abs(toNum(userareas[index1]?.spaceUsed) - spaceUsed) <= 0.01) return;

		const updatedAreas = [...userareas];
		updatedAreas[index1] = { ...updatedAreas[index1], spaceUsed };
		setAreas(updatedAreas);
	}


	const generateYearOptions = () => {
		const arr = [];

		const startYear = 2020;
		const endYear = new Date().getFullYear()+1;

		for (let i = endYear; i >= startYear; i--) {
			arr.push({"value": i,
				"text": i
			})
		}
		return arr;
	};

	function changeAreaName(areaIndex) {
		setName(areas[areaIndex].name)
		setCurrArea(areas[areaIndex])
		setTotalSpace(areas[areaIndex].info.totalSpace)
		setAreaYear(areas[areaIndex].year)
		setEditAreaModal(!editAreaModal)
	}

	function updateAreaYear(target) {
		setAreaYear(target.newValue)
	}

	function updateArea() {
		currArea.name = name
		if (!currArea.info)
			currArea.info = {}
		currArea.year = areaYear
		currArea.info.totalSpace = space
		setCurrArea(currArea)
		setEditAreaModal(!editAreaModal)
		onUpdateArea(currArea)
	}

	function cancelUpdateArea() {
		setCurrArea()
		setEditAreaModal(!editAreaModal)
	}

	function deleteArea(areaIndex) {
		setDeleteAreaIndex(areaIndex)
		setDeleteModal(true)
	}

	function confirmDeleteArea() {
		var newAreaList = [...userareas]
		newAreaList.splice(deleteAreaIndex, 1)
		setAreas(newAreaList)
		onDeleteArea(userareas[deleteAreaIndex].id)
		setDeleteModal(false)
		setDeleteAreaIndex(null)
	}

	function deleteAllPlantsInArea(areaIndex) {
		var newAreaList = [...userareas]
	}


	return (
		<div ref={drop}>
			<Card className="mb-1">

				<CardHeader style={{marginTop: "-10px", marginBottom: "-20px"}}>
					{/* ── Main header row ── */}
					<Row style={{width: "100%", paddingTop: "18px", paddingBottom: "18px", backgroundColor: "#BEC8B6", alignItems: "center"}}>
						{/* Area name + edit/delete + Add Plant */}
						<Col md={4} className="text-dark">
							<div onClick={() => { areaExpand[areaIndex] = !areaExpand[areaIndex]; setAreaExpand(areaExpand.map(x => x)) }} style={{cursor: "pointer", fontWeight: 600}}>
								{area.name}
							</div>
							{area.name !== 'Unassigned' && <div style={{ display:"flex", gap:"0.4rem", marginTop:"6px" }}>
								<button className="btn btn-sm" style={{ backgroundColor:"#7F8F7B", borderColor:"#7F8F7B", color:"#fff", padding:"3px 8px" }} onClick={() => changeAreaName(areaIndex)}>
									<i className="bx bx-edit-alt" />{" "}Edit
								</button>
								<button className="btn btn-sm" style={{ backgroundColor:"#7F8F7B", borderColor:"#7F8F7B", color:"#fff", padding:"3px 8px" }} onClick={() => deleteArea(areaIndex)}>
									<i className="bx bx-trash" />{" "}Delete
								</button>
								<button className="btn btn-sm" style={{ backgroundColor:"#7F8F7B", borderColor:"#7F8F7B", color:"#fff", padding:"3px 8px" }} onClick={() => { addPlant(areaIndex); if (!areaExpand[areaIndex]) { areaExpand[areaIndex]=true; setAreaExpand(areaExpand.map(x=>x)); } }}>
									<i className="bx bx-add-to-queue" />{" "}Add Plant
								</button>
							</div>}
						</Col>

						{/* Used Space */}
						{area.name !== 'Unassigned' &&
						<Col md={2} style={{cursor: "pointer"}} onClick={() => { areaExpand[areaIndex] = !areaExpand[areaIndex]; setAreaExpand(areaExpand.map(x => x)) }}>
							<span style={{fontSize: "0.9em"}}>
								Used Space: {(area.spaceUsed || 0).toFixed(1)}/{area.info.totalSpace} {unitmeasurement === "imperial" ? "ft²" : "m²"}
							</span>
						</Col>}

						{/* Harvest: actual / expected */}
						{area.name !== 'Unassigned' &&
						<Col md={2} style={{cursor: "pointer"}} onClick={() => { areaExpand[areaIndex] = !areaExpand[areaIndex]; setAreaExpand(areaExpand.map(x => x)) }}>
							<span style={{fontSize: "0.9em"}}>
								Harvest: {area.plants.filter(plant => {
									if (summer[areaIndex] && plant.season_rotation === "Summer") return true;
									if (spring[areaIndex] && plant.season_rotation === "Spring") return true;
									if (fall[areaIndex]   && plant.season_rotation === "Fall")   return true;
									if (winter[areaIndex] && plant.season_rotation === "Winter") return true;
									if (!summer[areaIndex] && !spring[areaIndex] && !fall[areaIndex] && !winter[areaIndex]) return true;
									return false;
								}).reduce((t, p) => t + (p.totalHarvest || 0) / 16.0, 0).toFixed(2)}
								&nbsp;/&nbsp;
								{area.plants.filter(plant => {
									if (summer[areaIndex] && plant.season_rotation === "Summer") return true;
									if (spring[areaIndex] && plant.season_rotation === "Spring") return true;
									if (fall[areaIndex]   && plant.season_rotation === "Fall")   return true;
									if (winter[areaIndex] && plant.season_rotation === "Winter") return true;
									if (!summer[areaIndex] && !spring[areaIndex] && !fall[areaIndex] && !winter[areaIndex]) return true;
									return false;
								}).reduce((t, p) => t + (typeof p.estHarvest === 'number' ? parseFloat(p.estHarvest) : 0), 0).toFixed(2)} lbs
							</span>
						</Col>}

						{/* Seasonal filters — always visible */}
						{area.name !== 'Unassigned' &&
						<Col md={4}>
							<div className="btn-group btn-group-toggle" data-toggle="buttons">
								{[
									{ label: "Spring", active: spring[areaIndex], onSet: () => { spring[areaIndex]=true;  summer[areaIndex]=false; fall[areaIndex]=false; winter[areaIndex]=false; setSpring(spring.map(x=>x)); setSummer(summer.map(x=>x)); setFall(fall.map(x=>x)); setWinter(winter.map(x=>x)); updateSpaceUsed(areaIndex); } },
									{ label: "Summer", active: summer[areaIndex], onSet: () => { summer[areaIndex]=true;  spring[areaIndex]=false; fall[areaIndex]=false; winter[areaIndex]=false; setSummer(summer.map(x=>x)); setSpring(spring.map(x=>x)); setFall(fall.map(x=>x)); setWinter(winter.map(x=>x)); updateSpaceUsed(areaIndex); } },
									{ label: "Fall",   active: fall[areaIndex],   onSet: () => { fall[areaIndex]=true;    spring[areaIndex]=false; summer[areaIndex]=false; winter[areaIndex]=false; setFall(fall.map(x=>x)); setSpring(spring.map(x=>x)); setSummer(summer.map(x=>x)); setWinter(winter.map(x=>x)); updateSpaceUsed(areaIndex); } },
									{ label: "Winter", active: winter[areaIndex], onSet: () => { winter[areaIndex]=true;  spring[areaIndex]=false; summer[areaIndex]=false; fall[areaIndex]=false; setWinter(winter.map(x=>x)); setSpring(spring.map(x=>x)); setSummer(summer.map(x=>x)); setFall(fall.map(x=>x)); updateSpaceUsed(areaIndex); } },
									{ label: "All",    active: !spring[areaIndex] && !summer[areaIndex] && !fall[areaIndex] && !winter[areaIndex], onSet: () => { spring[areaIndex]=false; summer[areaIndex]=false; fall[areaIndex]=false; winter[areaIndex]=false; setSpring(spring.map(x=>x)); setSummer(summer.map(x=>x)); setFall(fall.map(x=>x)); setWinter(winter.map(x=>x)); updateSpaceUsed(areaIndex); } },
								].map(({ label, active, onSet }) => (
									<label key={label} className={`btn btn-sm${active ? " btn-secondary active" : ""}`} style={active ? {} : {backgroundColor: "transparent", border: "1px solid #545a6d", color: "#545a6d"}}>
										<input type="radio" name={`season-${areaIndex}`} onClick={onSet} />{" "}{label}
									</label>
								))}
							</div>
						</Col>}

					</Row>
				</CardHeader>
				<Collapse style={{margin: "20px 0"}} isOpen={areaExpand[areaIndex]}>

					<Row>
						{area.plants.filter(plant => {
							if (summer[areaIndex] && plant.season_rotation=="Summer") {
								return plant;
							} else if (spring[areaIndex] && plant.season_rotation=="Spring") {
								return plant;
							} else if (fall[areaIndex] && plant.season_rotation=="Fall") {
								return plant;
							} else if (winter[areaIndex] && plant.season_rotation=="Winter") {
								return plant;
							}
							if (!summer[areaIndex] && !spring[areaIndex] && !fall[areaIndex] && !winter[areaIndex])
								return plant;
						}).filter((plant) => {
								// --- Completed/Failed visibility ---
								if (!showCompleted && (plant.status === "Complete" || plant.status === "Completed" || plant.status === "Failed")) {
									return false;
								}
								return true;
						}).map((plant, pindex) => (
							<Col md={3}>
								<Plant plant={plant} noteTags={noteTags} notes={notes}
									   noteDate={noteDate} setNoteDate={setNoteDate} setNotes={setNotes} setNoteTags={setNoteTags} addPlantLog={addPlantLog} deleteNote={deleteNote} addHarvest={addHarvest} deleteHarvest={deleteHarvest} profile={profile} deletePlant={deletePlant} climateAverages={climateAverages} calcPlantingCalendar={calcPlantingCalendar} currYear={currYear} plantingCalendarOptions={plantingCalendarOptions} unitmeasurement={unitmeasurement}
									   onGetCustomPlants={onGetCustomPlants} transferPlant={transferPlant} transferModal={transferModal} setTransferModal={setTransferModal} onUpdateCustomPlant={onUpdateCustomPlant} customPlantEdit={customPlantEdit} onSaveCustomPlant={onSaveCustomPlant} setAreas={setAreas} plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndex} plantIndex = {area.plants.indexOf(plant)} onUpdateArea={onUpdateArea} updateSpaceUsed={updateSpaceUsed}
									   timelineNotes={timelineNotes} onCreateJournalEntry={onCreateJournalEntry} onUpdateJournalEntry={onUpdateJournalEntry}/>
							</Col>
						))}
					</Row>
				</Collapse>
				{plantfamilyCard && <Collapse style={{margin: "20px 0"}} isOpen={areaExpand[areaIndex]}>
					<Row>
						<Col md={2}>
							<Family summer={summer} spring={spring} fall={fall} winter={winter} family="Brassica" familyStyle={"info"} setAreas={setAreas} plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndex} onUpdateArea={onUpdateArea} updateSpaceUsed={updateSpaceUsed} />

						</Col>
						<Col md={2}>
							<Family summer={summer} spring={spring} fall={fall} winter={winter} family="Solanaceae" familyStyle="danger" setAreas={setAreas} plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndex} onUpdateArea={onUpdateArea} updateSpaceUsed={updateSpaceUsed} />

						</Col>
						<Col md={2}>
							<Family summer={summer} spring={spring} fall={fall} winter={winter} family="Umbelliferae" familyStyle="warning" setAreas={setAreas} plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndex} onUpdateArea={onUpdateArea} updateSpaceUsed={updateSpaceUsed} />

						</Col>
						<Col md={2}>
							<Family summer={summer} spring={spring} fall={fall} winter={winter} family="Cucurbitae" familyStyle="success" setAreas={setAreas} plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndex} onUpdateArea={onUpdateArea} updateSpaceUsed={updateSpaceUsed} />

						</Col>
						<Col md={2}>
							<Family summer={summer} spring={spring} fall={fall} winter={winter} family="Legume" familyStyle="success" setAreas={setAreas} plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndex} onUpdateArea={onUpdateArea} updateSpaceUsed={updateSpaceUsed} />

						</Col>
						<Col md={2}>
							<Family summer={summer} spring={spring} fall={fall} winter={winter} family="Allium" familyStyle="warning" setAreas={setAreas} plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndex} onUpdateArea={onUpdateArea} updateSpaceUsed={updateSpaceUsed} />

						</Col>
						<Col md={2}>
							<Family summer={summer} spring={spring} fall={fall} winter={winter} family="Amaranth" familyStyle="success" setAreas={setAreas} plantMap={plantMap} areas={areas} userareas={userareas} areaIndex={areaIndex} onUpdateArea={onUpdateArea} updateSpaceUsed={updateSpaceUsed} />

						</Col>


					</Row>

				</Collapse>}


			</Card>
			<Modal isOpen={editAreaModal} toggle={() => {

			}}
			>
				<ModalHeader tag="h4">
					Edit Area
				</ModalHeader>
				<ModalBody>
					<Form>
						<Row>
							<Col md={6}><b>Name</b></Col>
							<Col md={6}>
								<Input type="text" value={name} onChange={event => {
									setName(event.target.value);
								}}
								/>
							</Col>
						</Row>
						<Row>
							<Col md={6}><b>Total Space ({unitmeasurement == "imperial" ? "ft²" : "m²"})</b></Col>
							<Col md={6}>
								<Input type="text" value={space} onChange={event => {
									setTotalSpace(event.target.value);
								}}
								/>
							</Col>
						</Row>
						<Row>
							<Col md={6}><b>Year</b></Col>
							<Col md={6}>
								<Editable
									name="plantingYear"
									value={areaYear}
									options={generateYearOptions()}
									dataType="select"
									display={(value) => {
										return (<span style={{color:"black"}}>{value}</span>);
									}}
									mode="inline"
									handleSubmit={updateAreaYear}
								/>
							</Col>
						</Row>
						<Row style={{ paddingTop: "10px"}}>
							<Col md="4"/>
							<Col md="2">
								<Button
									onClick={e => { updateArea()  }}
									color="success"
									className="btn-sm"
								>
									Update
								</Button>
							</Col>
							<Col md="2">
									<Button
										onClick={e => { cancelUpdateArea()  }}
										color="primary"
										className="btn-sm"
									>
										Cancel
									</Button>
							</Col>
						</Row>

					</Form>
				</ModalBody>
			</Modal>

		<Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)}>
				<ModalHeader toggle={() => setDeleteModal(false)}>Delete Area</ModalHeader>
				<ModalBody>
					Are you sure you want to delete <strong>{deleteAreaIndex !== null ? userareas[deleteAreaIndex]?.name : ""}</strong>? This will permanently remove the area and all its plants. This cannot be undone.
				</ModalBody>
				<ModalFooter>
					<button style={{ backgroundColor: "#BEC8B6", color: "#000", border: "1px solid #545a6d", borderRadius: "4px", padding: "4px 8px", cursor: "pointer", marginRight: "6px" }}
						onClick={confirmDeleteArea}>
						Delete
					</button>
					<button style={{ backgroundColor: "#BEC8B6", color: "#000", border: "1px solid #545a6d", borderRadius: "4px", padding: "4px 8px", cursor: "pointer" }}
						onClick={() => setDeleteModal(false)}>
						Cancel
					</button>
				</ModalFooter>
			</Modal>

		</div>
	);
}
export default Area;


